  <template >

 <div    >
     <template>
  <v-container class="grey lighten-5" v-role="'func'">
    <v-btn  class="mx-2" fab dark color="primary" @click="$router.push('menu-estatistica')">
      <v-icon dark>arrow_back</v-icon>
    </v-btn>
     <div class="text-center">
      <v-progress-circular v-if="progresso"
      indeterminate
      color="primary"
    >Aguarde...</v-progress-circular>

   </div>
    <v-row no-gutters>
      <v-col cols="12" md="1" >
         </v-col>
       <v-col cols="12" md="2" >
         <v-select
              v-model="editedItem.descricao"
              item-value="descricao"
              item-text="novadescricao"
              @change="quantAlunoTurma(editedItem.descricao)"
              :items="anoLectivo"
              :disabled="isUpdating"
              filled
              color="blue-grey lighten-2"
              label="Ano Lectivo"
            ></v-select>
          </v-col>
           <v-col cols="12" md="9">
      <input type="radio" name="gender" v-model="row" value="1" @change="positionLegend(row)"> Área
  <input type="radio" name="gender" v-model="row" value="2" @change="positionLegend(row)"> Barras
  <input type="radio" name="gender" v-model="row" value="3" @change="positionLegend(row)"> Pie
  <input type="radio" name="gender" v-model="row" value="4" @change="positionLegend(row)"> Radar
  <input type="radio" name="gender" v-model="row" value="5" @change="positionLegend(row)"> Line
            </v-col>
    </v-row>
<v-row>
        <v-col >

      <div class="container">
   <Doughnut
      v-if="loaded && row==='1'"
      :chartdata="chartdata"
      :options="options"/>

       <Bar
      v-if="loaded && row==='2'"
      :chartdata="chartdata"
      :options="options"/>

       <Pie
      v-if="loaded && row==='3'"
      :chartdata="chartdata"
      :options="options"/>

       <Radar
      v-if="loaded && row==='4'"
      :chartdata="chartdata"
      :options="options"/>

       <LineChart
      v-if="loaded && row==='5'"
      :chartdata="chartdata"
      :options="options"/>

  </div>

      </v-col>

    </v-row>
  </v-container>
</template>

 </div>
</template>

<script>
import axios from '../../../plugins/axios'
const ls = require('local-storage')
export default {
  name: 'BarChartContainer',
  components: {
    Doughnut: () => import('../../../components/Area.vue'),
    Bar: () => import('../../../components/Bar.vue'),
    LineChart: () => import('../../../components/Chart.vue'),
    Radar: () => import('../../../components/Radar.vue'),
    Pie: () => import('../../../components/Pie.vue')
  },
  data: () => ({
    row: '1',
    loaded: false,
    progresso: false,
    isUpdating: false,
    turmas: [],
    quantProfessores: [],
    backgroundColor: ['rgba(255, 99, 71, 0.8)', 'rgb(60, 179, 113)', 'rgb(0, 0, 255)', 'rgb(255, 165, 0)', 'rgb(0, 0, 0)', 'rgb(238, 130, 238)', '#663399', '#800000', '#FFA07A'],
    anoLectivo: [],
    professores: [],
    datasetsOtherGraphics: [],
    editedItem: {
      idAnoLectivo: 0,
      descricao: ls.get('anolectivo'),
      status_2: false
    },
    chartdata: {
      labels: [],
      datasets: [
        {
          label: 'Quantidade de Professores nas turmas',
          backgroundColor: ['rgba(255, 99, 71, 0.8)', 'rgb(60, 179, 113)', 'rgb(0, 0, 255)', 'rgb(255, 165, 0)', 'rgb(0, 0, 0)', 'rgb(238, 130, 238)', '#663399', '#800000', '#FFA07A'],
          data: []
        }

      ]
    },

    options: {
      responsive: true,
      legend: {
        display: true,
        position: 'top',
        labels: {
          fontColor: 'rgb(255, 99, 132)'
        }
      },
      maintainAspectRatio: false
    }
  }),
  created  () {
    this.anoLectivoAll()
    this.quantAlunoTurma(ls.get('anolectivo'))
    this.positionLegend(this.row)
  },
  async mounted () {
    this.loaded = false
    try {
      //  const { userlist } = await fetch('/api/userlist')
      // this.chartdata = ['January', 'February']
      this.loaded = true
    } catch (e) {
      console.error(e)
    }
  },
  methods: {
    async anoLectivoAll () {
      try {
        this.anoLectivo = await axios
          .get('/allAnoLectivo/')
          .then(res => res.data)
        this.row = '1'
      } catch (error) {
        console.log('errrrrrrrrrrrrrrrrrrro' + error)
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async quantAlunoTurma (anolectivo) {
      this.progresso = true

      try {
        this.professores = await axios
          .get('/quantidadeFuncionarios_Turma/' + anolectivo)
          .then(res => res.data)
        this.filterProfessores_Turma()
        this.progresso = false
      } catch (error) {
        this.progresso = false
        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    positionLegend (row) {
      if (row === '1' || row === '3') {
        this.options.legend.position = 'left'
      } else {
        this.options.legend.position = 'top'
      }
    },
    filterProfessores_Turma () {
      this.turmas = []
      this.quantProfessores = []
      for (let index = 0; index < this.professores.length; index++) {
        this.turmas[index] = ('Turmas de ' + this.professores[index].curso)
        this.quantProfessores[index] = (this.professores[index].quantidade)
      }
      this.chartdata.labels = this.turmas
      this.chartdata.datasets[0].data = this.quantProfessores
      this.loaded = false
      this.$nextTick(() => {
        this.loaded = true
      })
    }

  }
}

</script>

<style>
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
</style>
